var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group',{attrs:{"id":_vm.id,"append":_vm.append,"append-html":_vm.appendHtml,"prepend":_vm.prepend,"prepend-html":_vm.prependHtml,"size":_vm.size,"tag":_vm.tag}},[_vm._t("prepend"),_vm._t("default"),_vm._t("append")],2)}
var staticRenderFns = []

export { render, staticRenderFns }